export const selectUserId = ({ user }) => user?.userId;
